import { ISkid } from '@models';
import axiosInstance from './axiosInstance';

const GET_CALC_SKIDS = (id: number) => `/svc/calcSkids/${id}`;

export async function getCalcSkids(id: number): Promise<ISkid[]> {
	const response = await axiosInstance.get(GET_CALC_SKIDS(id));
	return response.data;
}
